"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M3.329 12a2 2 0 114 0 2 2 0 01-4 0zM10.33 12a2 2 0 114 0 2 2 0 01-4 0zM19.332 10a2 2 0 100 4 2 2 0 000-4z" }), "More");
//# sourceMappingURL=More.js.map